var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 18,
    viewBox: "0 0 7 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1318_8061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 15.7496H4.5V7.87465C4.5 7.25273 3.99621 6.74965 3.375 6.74965H1.125C0.503789 6.74965 0 7.25273 0 7.87465C0 8.49656 0.503789 8.96801 1.125 8.96801H2.25V15.718H1.125C0.503789 15.718 0 16.2211 0 16.843C0 17.4649 0.503789 17.968 1.125 17.968H5.625C6.24621 17.968 6.75 17.4649 6.75 16.843C6.75 16.2211 6.24727 15.7496 5.625 15.7496ZM3.375 4.49965C4.30699 4.49965 5.0625 3.74414 5.0625 2.81215C5.0625 1.88016 4.30664 1.125 3.375 1.125C2.44336 1.125 1.6875 1.88051 1.6875 2.8125C1.6875 3.74449 2.44301 4.49965 3.375 4.49965Z",
    fill: "#D4D4D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1318_8061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.75,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.212550e9.svg";
export { ForwardRef as ReactComponent };